export enum InvoiceStatus {
  PENDING = "pending",
  CANCELED = "canceled",
  COMPLETED = "completed",
}
